import _ from 'lodash';
import apolloClient from '@/store/apollo';

import PageGql from '@/store/graphql/queries/Page.gql';
import CreatePageGql from '@/store/graphql/mutations/CreatePage.gql';
import PagesPaginatedGql from '@/store/graphql/queries/PagesPaginated.gql';

export default {
    fetchPagesPaginated: data =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: PagesPaginatedGql,
                    variables: {
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'publish_start'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        filters
                    }
                })
                .then(({ data }) => resolve(data.CP_PagesPaginated))
                .catch(error => reject(error));
        }),
    fetchPage: variables => {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: PageGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_Page))
                .catch(error => reject(error));
        });
    },
    create: page => {
        if (page === undefined) throw new Error('required argument is missing');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreatePageGql,
                    variables: { page }
                })
                .then(({ data }) => resolve(data.CreatePage))
                .catch(err => reject(err));
        });
    }
};
